import { gql } from 'apollo-angular';
import { ADDRESS_GROUP_FIELDS_FRAGMENT } from "./address-group-definition";
import { DISCOUNT_GROUP_RELATION_DOCUMENT_BASE_FRAGMENT } from "./discount-group.definition";
import { DELETION_RESPONSE_FRAGMENT } from './system-definition';

export const DISCOUNT_GROUP_VENDOR_GROUP_RELATION_FRAGMENT = gql`
fragment DiscountGroupVendorGroupRelation on DiscountGroupVendorGroupRelation {
    ...DiscountGroupRelationDocumentBase
    vendorGroupId
    vendorGroup {
        ...AddressGroupFields
    }
}
${DISCOUNT_GROUP_RELATION_DOCUMENT_BASE_FRAGMENT}
${ADDRESS_GROUP_FIELDS_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_VENDOR_GROUP_RELATIONS = gql`
query GetDiscountGroupVendorGroupRelations($input:DiscountGroupVendorGroupRelationSearchInput) {
    getDiscountGroupVendorGroupRelations(input: $input) {
        totalItems
        items {
            ...DiscountGroupVendorGroupRelation
        }
    }
}
${DISCOUNT_GROUP_VENDOR_GROUP_RELATION_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_VENDOR_GROUP_RELATION = gql`
query GetDiscountGroupVendorGroupRelation($id:String!) {
    getDiscountGroupVendorGroupRelation(id: $id) {
        ...DiscountGroupVendorGroupRelation
    }
}
${DISCOUNT_GROUP_VENDOR_GROUP_RELATION_FRAGMENT}
`;


export const SAVE_DISCOUNT_GROUP_VENDOR_GROUP_RELATION = gql`
mutation SaveDiscountGroupVendorGroupRelation($input: DiscountGroupVendorGroupRelationInput!) {
    saveDiscountGroupVendorGroupRelation(input: $input) {
        ... DiscountGroupVendorGroupRelation
    }
}
${DISCOUNT_GROUP_VENDOR_GROUP_RELATION_FRAGMENT}
`;

export const DELETE_DISCOUNT_GROUP_VENDOR_GROUP_RELATION = gql`
mutation DeleteDiscountGroupVendorGroupRelation($id: String!) {
    deleteDiscountGroupVendorGroupRelation(id: $id) {
        ... DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;